<template>
  <section class="app-main">
    <el-card class="m-bottom-4">
      <el-row class="m-bottom-4">
        <el-col>
          <el-date-picker
            v-model="fixDate"
            @change="handleDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="margin-top: 10px"
          >
          </el-date-picker>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="m-bottom-4">
      <el-row>
      
          <div ref="echarts" style="width: 100%; height: 500px;text-ali"></div>
    
      </el-row>
    </el-card>
  </section>
</template>

<script>
import { statistics_order_area } from "@/api/summary.js";

export default {
  data() {
    return {
      fixDate: [],
      numberData: [],
      chart: null,
    };
  },
  mounted() {
    //this.getPie();
     this.handleData();
  },
  methods: {
    getPie(data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(this.$refs.echarts);
      // 绘制图表，this.echarts1_option是数据
      myChart.setOption({
        legend: {
            type: 'scroll',
            orient: 'vertical',
            right: 10,
            top: 0,
            bottom: 20,
            data: data.name,
        },
        series: [
          {
            name: "用户下单城市统计",
            type: "pie",
            radius: "55%",
            data: data,
          },
        ],
      });
    },

    // 日期查询搜索
    handleDate() {
      this.handleData();
    },

    handleData() {
      let params = {};
      if (this.fixDate && this.fixDate.length != 0) {
        params.start_date_search = this.fixDate[0];
        params.end_date_search = this.fixDate[1];
      }
      statistics_order_area(params).then((res) => {
        if (res) {
            this.getPie(res.data);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>
